const historycalls = (state = [], action) => {
    switch (action.type) {
      case 'HISTORYCCALLS':
      return {
          type: "HISTORYCCALLS",
          historycalls: action.historycalls
        }
      default:
        return state
    }
  }
  
  export default historycalls